import {
  ChakraProvider,
  createSystem,
  defaultConfig,
  defineConfig,
  Box,
} from "@chakra-ui/react"

import './styles.css'

import { Toaster } from "./components/ui/toaster"

import Navbar from "./components/Navbar"
import HomeBanner from "./components/HomeBanner"
import AboutUs from "./components/AboutUs"
import Gallery from "./components/Gallery"
import Contact from "./components/Contact"
import Footer from "./components/Footer"

const config = defineConfig({
  theme: {
    tokens: {
      colors: {},
    },
  },
})

const system = createSystem(defaultConfig, config)

export default function App() {
  return (
    <ChakraProvider value={system}>
      <Navbar />
      <Toaster />
      <Box pt="80px">
        <HomeBanner />
        <AboutUs />
        <Gallery />
        <Contact />
        <Footer />
      </Box>
    </ChakraProvider>
  )
}
